// dependencies
import React from "react";
import { useIntl } from "react-intl";

// components
import Stack from "@cloudspire/legacy-resources/src/components/Stack";
import Breadcrumb from "@cloudspire/legacy-resources/src/components/Breadcrumb";
import UIContainer from "@cloudspire/legacy-resources/src/components/UIContainer";
import Content from "@cloudspire/legacy-resources/src/components/Content";
import HasSeenRoom from "../../components/HasSeenRoom";

// containers
import SearchContainer from "./Search";
import LastSeenRoomContainer from "../LastSeenRoom";
import RoomListSEO from "./SEO";

// constants
import { searchDefaultParameters } from "../../constants/search";

// contexts
import { useRoute } from "@cloudspire/legacy-resources/src/contexts/route";
import { useRouters } from "@cloudspire/legacy-resources/src/contexts/routers";

// hocs
import useViewportMedia from "@cloudspire/legacy-resources/src/hocs/useViewportMedia";

// helpers
import { contentGenerateBreacrumbItemList } from "@cloudspire/legacy-resources/src/helpers/content";

// api
import { contentRoomListPage } from "@cloudspire/legacy-resources/src/api/content";

// hooks
import { useResponse } from "@cloudspire/legacy-resources/src/hooks/fetcher";

function RoomListContainer(props) {
  const { useContent, category } = props;

  const { frontRouter } = useRouters();

  const route = useRoute();

  const query = route.getUri().getParsedQuery();

  const intl = useIntl();

  const { data: contentShow } = useResponse(
    contentRoomListPage({
      useContent,
      preview: "1" === query.preview ? "1" : undefined,
      slug: route.getParameter("slug"),
      query: {
        ...searchDefaultParameters,
      },
    })
  );

  const { matches: matchesSm } = useViewportMedia({
    queries: [{ minWidth: 605 }],
  });

  return (
    <>
      <RoomListSEO useContent={useContent} content={contentShow?.data} />

      <Stack marginTop={1} />

      <UIContainer isFullWidth={true}>
        {useContent && (
          <>
            <Breadcrumb
              itemList={contentGenerateBreacrumbItemList({
                intl,
                content: contentShow.data,
                route,
                router: frontRouter,
              })}
            />

            <Stack marginTop={1} />

            <Content
              about={contentShow.data.about}
              content={contentShow.data.content}
              subtitle={contentShow.data.subtitle}
              landscapeUri={contentShow.data.landscapeUri}
              title={contentShow.data.title}
            />

            {matchesSm && <Stack marginTop={1} />}
          </>
        )}

        <SearchContainer category={category} />
      </UIContainer>

      <HasSeenRoom>
        <Stack marginTop={1} />
        <LastSeenRoomContainer />
      </HasSeenRoom>
    </>
  );
}

export default RoomListContainer;
